<div #menuContainer class="ax-base-context-menu__container">
    <ng-template ax-context-menu></ng-template>
</div>
